import React, { createContext, type ReactNode, useContext } from 'react'
import { LeavingFamilySearchToWikiTreeDialog } from '@fs/zion-tree-groups'
import { useOverlay, type UseOverlayReturnOptions } from '@fs/zion-ui'
import { targetEnv } from '@fs/zion-config'
import { useFocusPID } from './FocusPIDContext'

const WikiTree = createContext<UseOverlayReturnOptions | null>(null)

export const useWikiTree = (): UseOverlayReturnOptions => {
  const context = useContext(WikiTree)
  if (!context) throw new Error('useWikiTree must be wrapped with WikiTreeProvider.')
  return context
}

export default function WikiTreeProvider({ children }: { children: ReactNode }): JSX.Element {
  const overlay = useOverlay()
  const pid = useFocusPID()
  const baseUrl = targetEnv === 'prod' ? 'https://www.wikitree.com' : 'https://dev-www.wikitree.com'

  return (
    <WikiTree.Provider value={overlay}>
      {children}
      {(overlay.isOpen || overlay.transitioning) && (
        <LeavingFamilySearchToWikiTreeDialog overlay={overlay} to={`${baseUrl}/fsid/${pid}`} />
      )}
    </WikiTree.Provider>
  )
}
